import { RegisterOptions, useFormContext } from "react-hook-form";
import { Switch } from "../../CardsPages/Forms/Switch";

type SwitchProps = Parameters<typeof Switch>[0];
interface IFormSwitchProps extends SwitchProps {
    ref?: never;
    name: string;
    registerOptions?: RegisterOptions;
}

export default function FormSwitch(props: IFormSwitchProps) {
    const { registerOptions, ...switchProps } = props;

    const { register } = useFormContext();

    return <Switch {...switchProps} ref={register(registerOptions)} />;
}
